import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import styles from "./ThumbnailsRow.module.scss";

type ThumbnailsRowProps = {
	imageUrl: string;
	mask?: string;

	onImageClick?: (imageUrl: string) => void;
	onMaskClick?: (mask: string) => void;
};

const ThumbnailsRow = ({ imageUrl, mask, onImageClick, onMaskClick }: ThumbnailsRowProps) => {
	return (
		<Box className={styles.extraResultInfo}>
			<img src={imageUrl} alt="image thumbnail" onClick={() => onImageClick?.(imageUrl)} />
			{mask && <img src={mask} alt="mask thumbnail" onClick={() => onMaskClick?.(mask)} />}
		</Box>
	);
};

export default observer(ThumbnailsRow);
